/* Resource inclusions and unit ordering, independent of purchase and search scripts. */
(() => {
  'use strict';
  let verification=document.getElementById('cr-footer-verification');
  if(!verification&&document.querySelector('.cr-footer-preferences')){verification=document.createElement('div');verification.id='cr-footer-verification';verification.setAttribute('aria-label','Website verification');document.querySelector('.cr-footer-preferences').append(verification);}
  if(verification){
    const placeBadge=()=>{const badge=document.querySelector('.ti-widget[data-layout-id="74"]');if(!badge)return false;if(badge.parentElement!==verification)verification.append(badge);return true;};
    if(!placeBadge()){const observer=new MutationObserver(()=>{if(placeBadge())observer.disconnect();});observer.observe(document.body,{childList:true,subtree:true});}
  }
  document.querySelectorAll('.cr-product-description,.coverage-prose,.original-content').forEach(root => {
    const disclosures=[];
    root.querySelectorAll('button.accordion1').forEach(button => {
      const panel=button.nextElementSibling;
      if(!panel?.classList.contains('panel1')||button.closest('details'))return;
      const details=document.createElement('details'),summary=document.createElement('summary');
      details.className='cr-inclusion'; summary.textContent=button.textContent.trim();
      panel.hidden=false; panel.removeAttribute('style');
      const empty=node=>node?.nodeName==='BR'||(node?.nodeType===3&&!node.textContent.trim());
      while(empty(panel.firstChild))panel.firstChild.remove();
      while(empty(panel.lastChild))panel.lastChild.remove();
      button.replaceWith(details); details.append(summary,panel); disclosures.push(details);
    });
    if(disclosures.length){
      const controls=document.createElement('div');controls.className='cr-inclusion-controls';
      const hint=document.createElement('p');hint.textContent='Select a heading to view the resource inclusions.';
      const toggle=document.createElement('button');toggle.type='button';
      const sync=()=>{const all=disclosures.every(d=>d.open);toggle.textContent=all?'Collapse all inclusions':'Expand all inclusions';toggle.setAttribute('aria-expanded',String(all));};
      toggle.addEventListener('click',()=>{const open=!disclosures.every(d=>d.open);disclosures.forEach(d=>d.open=open);sync();});
      disclosures.forEach(d=>d.addEventListener('toggle',sync));sync();controls.append(hint,toggle);disclosures[0].before(controls);
    }
    root.querySelectorAll('table').forEach(table => {
      const code=/^((?:[A-Z]{2,8}\d{3,8}|\d{5}[A-Z]{3}))(?:\s+(.+))?$/;
      let unitCount=0;
      for(const body of table.tBodies){
        let group=[];
        const flush=()=>{if(group.length>1){const marker=document.createComment('unit-order');group[0].before(marker);group.sort((a,b)=>a.cells[0].textContent.trim().localeCompare(b.cells[0].textContent.trim(),'en',{numeric:true})).forEach(row=>marker.before(row));marker.remove();}group=[];};
        for(const row of [...body.rows]){
          const match=row.cells.length>=2&&row.cells[0].textContent.trim().match(code);
          if(match){
            if(match[2]&&(!row.cells[1].textContent.trim()||/^Group\s+[A-Z0-9]+$/i.test(row.cells[1].textContent.trim()))&&!row.cells[0].children.length){const groupLabel=row.cells[1].textContent.trim();row.cells[0].textContent=match[1];row.cells[1].textContent=match[2];if(groupLabel){const badge=document.createElement('span');badge.className='cr-unit-group';badge.textContent=groupLabel;row.cells[1].append(badge);}}
            group.push(row);unitCount++;
          }else flush();
        }
        flush();
      }
      if(unitCount){
        table.classList.add('cr-unit-table');
        if(!table.caption){const caption=table.createCaption();caption.textContent='Included units: A–Z by unit code within each group';}
      }
    });
  });
})();
